import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-truco-dark border-t border-truco-surface" data-id="element-63">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-truco-surface to-black border border-truco-gold/30 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-65">
          <div className="absolute -top-10 -right-10 text-truco-gold/5" data-id="element-66">
            <ShieldCheckIcon className="w-64 h-64" data-id="element-67" />
          </div>

          <div className="relative z-10" data-id="element-68">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-truco-gold/10 mb-6" data-id="element-69">
              <ShieldCheckIcon className="w-10 h-10 text-truco-gold" data-id="element-70" />
            </div>

            <h2 className="text-3xl font-heading font-black text-truco-cream mb-6" data-id="element-71">
              GARANTÍA TOTAL 7 DÍAS
            </h2>

            <p className="text-xl text-truco-creamMuted mb-6" data-id="element-72">
              Usá el sistema durante una semana completa.
            </p>

            <div className="text-left max-w-md mx-auto mb-8 bg-truco-dark/50 p-6 rounded-xl border border-truco-gold/10" data-id="element-73">
              <p className="text-truco-cream font-medium mb-4" data-id="element-74">Si no sentís:</p>
              <ul className="space-y-3 text-truco-creamMuted" data-id="element-75">
                <li className="flex items-start gap-2" data-id="element-76">
                  <span className="text-truco-gold font-bold" data-id="element-77">•</span>
                  Más claridad sobre qué hacer en cada mano
                </li>
                <li className="flex items-start gap-2" data-id="element-78">
                  <span className="text-truco-gold font-bold" data-id="element-79">•</span>
                  Menos dudas cuando te cantan Falta Envido o Vale Cuatro
                </li>
                <li className="flex items-start gap-2" data-id="element-80">
                  <span className="text-truco-gold font-bold" data-id="element-81">•</span>
                  Al menos una partida ganada que antes hubieras perdido
                </li>
              </ul>
            </div>

            <p className="text-xl font-bold text-truco-cream mb-2" data-id="element-82">
              Te devolvemos el 100% del dinero.
            </p>
            <p className="text-truco-gold font-medium" data-id="element-83">
              Sin preguntas. Sin formularios. Sin vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}